webpackJsonp([19],{

/***/ 1125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AffectedResultsView_vue__ = __webpack_require__(1286);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070b7d2c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AffectedResultsView_vue__ = __webpack_require__(1468);
function injectStyle (ssrContext) {
  __webpack_require__(1461)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-070b7d2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AffectedResultsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070b7d2c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AffectedResultsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ActionGateModal__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BoyStatus_AffectedResultsTable__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__composables_useAffectedResults__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__composables_useActionGate__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_date__ = __webpack_require__(148);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










function extractError(err) {
  var data = err.response != null ? err.response.data : null;
  return data != null && data.message != null ? data.message : 'A server error occurred. Please try again later.';
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'AffectedResultsView',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_3__components_AppButton__["a" /* default */],
    ActionGateModal: __WEBPACK_IMPORTED_MODULE_4__components_ActionGateModal__["a" /* default */],
    AffectedResultsTable: __WEBPACK_IMPORTED_MODULE_5__components_BoyStatus_AffectedResultsTable__["a" /* default */]
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: function validator(value) {
        return ['rider', 'horse'].includes(value);
      }
    },
    entityId: {
      type: [String, Number],
      required: true
    },
    stateId: {
      type: [String, Number],
      required: true
    }
  },
  setup: function setup(props) {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var _useAffectedResults = Object(__WEBPACK_IMPORTED_MODULE_6__composables_useAffectedResults__["a" /* default */])(props.type),
        state = _useAffectedResults.state,
        results = _useAffectedResults.results,
        otherResults = _useAffectedResults.otherResults,
        loading = _useAffectedResults.loading,
        previewing = _useAffectedResults.previewing,
        previewed = _useAffectedResults.previewed,
        recalculating = _useAffectedResults.recalculating,
        fetchAffected = _useAffectedResults.fetchAffected,
        preview = _useAffectedResults.preview,
        confirmRecalculate = _useAffectedResults.confirmRecalculate;

    var actionGate = Object(__WEBPACK_IMPORTED_MODULE_7__composables_useActionGate__["a" /* default */])();
    var error = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var affectedResultsCount = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return results.value.filter(function (row) {
        return String(row.points) !== String(row.points_after);
      }).length;
    });
    var hasChanges = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return affectedResultsCount.value > 0 || otherResults.value.length > 0;
    });
    var changedCount = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return affectedResultsCount.value + otherResults.value.length;
    });

    function goBack() {
      var profileName = props.type === 'horse' ? 'horses' : 'members';
      proxy.$router.push("/".concat(profileName, "/").concat(props.entityId, "#boy-history"));
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      proxy.$nextTick(function () {
        proxy.$root.$emit('update-breadcrumb', {
          name: props.type === 'horse' ? 'Horse Profile' : 'Member Profile',
          link: "".concat(props.type === 'horse' ? 'horses' : 'members', "/").concat(props.entityId, "#boy-history")
        });
      });
      actionGate.runGated(function () {
        return fetchAffected(props.entityId, props.stateId);
      }).catch(function (err) {
        if (!err.isGateCancelled) error.value = extractError(err);
      });
    });

    function handlePreview() {
      return _handlePreview.apply(this, arguments);
    }

    function _handlePreview() {
      _handlePreview = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                error.value = null;
                _context.prev = 1;
                _context.next = 4;
                return actionGate.runGated(function () {
                  return preview(props.entityId, props.stateId);
                });

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);
                if (!_context.t0.isGateCancelled) error.value = extractError(_context.t0);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 6]]);
      }));
      return _handlePreview.apply(this, arguments);
    }

    function handleConfirm() {
      return _handleConfirm.apply(this, arguments);
    }

    function _handleConfirm() {
      _handleConfirm = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                error.value = null;
                _context2.prev = 1;
                _context2.next = 4;
                return actionGate.runGated(function () {
                  return confirmRecalculate(props.entityId, props.stateId);
                });

              case 4:
                goBack();
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);
                if (!_context2.t0.isGateCancelled) error.value = extractError(_context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 7]]);
      }));
      return _handleConfirm.apply(this, arguments);
    }

    return _objectSpread({
      state: state,
      results: results,
      otherResults: otherResults,
      loading: loading,
      previewing: previewing,
      previewed: previewed,
      recalculating: recalculating,
      error: error,
      hasChanges: hasChanges,
      affectedResultsCount: affectedResultsCount,
      changedCount: changedCount,
      formatDate: __WEBPACK_IMPORTED_MODULE_8__utils_date__["a" /* formatDate */],
      goBack: goBack,
      handlePreview: handlePreview,
      handleConfirm: handleConfirm
    }, actionGate);
  }
}));

/***/ }),

/***/ 1287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_date__ = __webpack_require__(148);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'AffectedResultsTable',
  props: {
    rows: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    previewed: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'single',
      validator: function validator(value) {
        return ['single', 'both'].includes(value);
      }
    },
    entityLabel: {
      type: String,
      default: ''
    },
    entityField: {
      type: String,
      default: ''
    },
    emptyText: {
      type: String,
      default: 'No results found for this period.'
    }
  },
  setup: function setup(props) {
    var entities = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.mode === 'both' ? [{
        label: 'Rider',
        field: 'rider'
      }, {
        label: 'Horse',
        field: 'horse'
      }] : [{
        label: props.entityLabel,
        field: props.entityField
      }];
    });
    var colspan = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return 7 + entities.value.length + (props.previewed ? 1 : 0);
    });

    function isAffected(row) {
      return props.previewed && String(row.points) !== String(row.points_after);
    }

    function draftLink(row) {
      return "/drafts-list/".concat(row.draft.id, "/events-list");
    }

    function eventLink(row) {
      return "/drafts-list/".concat(row.draft.id, "/events-list/event-create/").concat(row.event.id);
    }

    return {
      entities: entities,
      colspan: colspan,
      formatDate: __WEBPACK_IMPORTED_MODULE_1__utils_date__["a" /* formatDate */],
      isAffected: isAffected,
      draftLink: draftLink,
      eventLink: eventLink
    };
  }
}));

/***/ }),

/***/ 1461:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1462);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("29052d06", content, true, {});

/***/ }),

/***/ 1462:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(1094);
exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, "@media (max-width:500px){.affected-results__header[data-v-070b7d2c]{flex-direction:column;align-items:stretch;gap:.75rem;margin-bottom:1rem}}.affected-results__state[data-v-070b7d2c]{display:flex;flex-wrap:wrap;gap:.5rem 1.5rem}.draws-dashboard__warn-icon[data-v-070b7d2c]{display:inline-block;background-image:url(" + escape(__webpack_require__(1095)) + ");background-size:99px 97px;background-position:-22px 0;width:21px;height:18px;vertical-align:middle;margin-left:.4rem}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/BoyStatus/AffectedResults/AffectedResultsView.vue"],"names":[],"mappings":"AACA,yBACA,2CACI,sBAAuB,AACvB,oBAAqB,AACrB,WAAa,AACb,kBAAoB,CACvB,CACA,AACD,0CACE,aAAc,AACd,eAAgB,AAChB,gBAAmB,CACpB,AACD,6CACE,qBAAsB,AACtB,+CAAkD,AAClD,0BAA2B,AAC3B,4BAA+B,AAC/B,WAAY,AACZ,YAAa,AACb,sBAAuB,AACvB,iBAAoB,CACrB","file":"AffectedResultsView.vue","sourcesContent":["\n@media (max-width: 500px) {\n.affected-results__header[data-v-070b7d2c] {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n}\n}\n.affected-results__state[data-v-070b7d2c] {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 1.5rem;\n}\n.draws-dashboard__warn-icon[data-v-070b7d2c] {\n  display: inline-block;\n  background-image: url('~@/assets/img/sprite.png');\n  background-size: 99px 97px;\n  background-position: -22px 0px;\n  width: 21px;\n  height: 18px;\n  vertical-align: middle;\n  margin-left: 0.4rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AffectedResultsTable_vue__ = __webpack_require__(1287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79319141_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AffectedResultsTable_vue__ = __webpack_require__(1466);
function injectStyle (ssrContext) {
  __webpack_require__(1464)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79319141"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AffectedResultsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79319141_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AffectedResultsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1464:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1465);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("0f6d876d", content, true, {});

/***/ }),

/***/ 1465:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(1094);
exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".col-points-after[data-v-79319141]{width:140px;white-space:nowrap}.draws-dashboard__warn-icon[data-v-79319141]{display:inline-block;background-image:url(" + escape(__webpack_require__(1095)) + ");background-size:99px 97px;background-position:-22px 0;width:21px;height:18px;vertical-align:middle;margin-left:.4rem}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/BoyStatus/AffectedResultsTable.vue"],"names":[],"mappings":"AACA,mCACE,YAAa,AACb,kBAAoB,CACrB,AACD,6CACE,qBAAsB,AACtB,+CAAkD,AAClD,0BAA2B,AAC3B,4BAA+B,AAC/B,WAAY,AACZ,YAAa,AACb,sBAAuB,AACvB,iBAAoB,CACrB","file":"AffectedResultsTable.vue","sourcesContent":["\n.col-points-after[data-v-79319141] {\n  width: 140px;\n  white-space: nowrap;\n}\n.draws-dashboard__warn-icon[data-v-79319141] {\n  display: inline-block;\n  background-image: url('~@/assets/img/sprite.png');\n  background-size: 99px 97px;\n  background-position: -22px 0px;\n  width: 21px;\n  height: 18px;\n  vertical-align: middle;\n  margin-left: 0.4rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative",staticStyle:{"min-height":"150px"}},[(_vm.loading)?_c('div',{staticClass:"table-overlay"},[_c('div',{staticClass:"table-spinner"})]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-striped table-sm mb-0"},[_c('thead',{staticClass:"thead-dark text-uppercase"},[_c('tr',[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Draft")]),_vm._v(" "),_c('th',{staticClass:"d-none d-lg-table-cell"},[_vm._v("Zone")]),_vm._v(" "),_c('th',{staticClass:"d-none d-lg-table-cell"},[_vm._v("Event")]),_vm._v(" "),_vm._l((_vm.entities),function(entity){return _c('th',{key:entity.field,staticClass:"d-none d-lg-table-cell"},[_vm._v(_vm._s(entity.label))])}),_vm._v(" "),_c('th',[_vm._v("Place")]),_vm._v(" "),_c('th',{staticClass:"d-none d-lg-table-cell"},[_vm._v("Score")]),_vm._v(" "),_c('th',{staticClass:"d-none d-lg-table-cell"},[_vm._v("Points")]),_vm._v(" "),(_vm.previewed)?_c('th',{staticClass:"d-none d-lg-table-cell col-points-after"},[_vm._v("Points After")]):_vm._e()],2)]),_vm._v(" "),(_vm.rows.length)?_c('tbody',_vm._l((_vm.rows),function(row){return _c('tr',{key:row.id,class:{ 'table-warning': _vm.isAffected(row) }},[_c('td',[_vm._v(_vm._s(_vm.formatDate(row.draft.start_date, 'long')))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":_vm.draftLink(row),"target":"_blank","rel":"noreferrer"}},[_vm._v(_vm._s(row.draft.name))]),_vm._v(" "),_c('div',{staticClass:"d-lg-none"},[_c('div',[_vm._v("Zone: "+_vm._s(row.zone.name))]),_vm._v(" "),_c('div',[_vm._v("Event: "),_c('a',{attrs:{"href":_vm.eventLink(row),"target":"_blank","rel":"noreferrer"}},[_vm._v(_vm._s(row.event.name))])]),_vm._v(" "),_vm._l((_vm.entities),function(entity){return _c('div',{key:entity.field},[_vm._v("\n              "+_vm._s(entity.label)+": "),(row[entity.field])?[_vm._v(_vm._s(row[entity.field].name)),(row[entity.field].deleted)?_c('small',[_vm._v(" (deleted)")]):_vm._e()]:_vm._e()],2)})],2)]),_vm._v(" "),_c('td',{staticClass:"d-none d-lg-table-cell"},[_vm._v(_vm._s(row.zone.name))]),_vm._v(" "),_c('td',{staticClass:"d-none d-lg-table-cell"},[_c('a',{attrs:{"href":_vm.eventLink(row),"target":"_blank","rel":"noreferrer"}},[_vm._v(_vm._s(row.event.name))])]),_vm._v(" "),_vm._l((_vm.entities),function(entity){return _c('td',{key:entity.field,staticClass:"d-none d-lg-table-cell"},[(row[entity.field])?[_vm._v(_vm._s(row[entity.field].name)),(row[entity.field].deleted)?_c('small',[_vm._v(" (deleted)")]):_vm._e()]:_vm._e()],2)}),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(row.place)+"\n          "),_c('div',{staticClass:"d-lg-none"},[_c('div',[_vm._v("Score: "+_vm._s(row.score))]),_vm._v(" "),_c('div',[_vm._v("Points: "+_vm._s(row.points))]),_vm._v(" "),(_vm.previewed)?_c('div',[_vm._v("\n              Points After: "+_vm._s(row.points_after)+"\n              "),(_vm.isAffected(row))?_c('span',{staticClass:"draws-dashboard__warn-icon",attrs:{"title":"Points changed"}}):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('td',{staticClass:"d-none d-lg-table-cell"},[_vm._v(_vm._s(row.score))]),_vm._v(" "),_c('td',{staticClass:"d-none d-lg-table-cell"},[_vm._v(_vm._s(row.points))]),_vm._v(" "),(_vm.previewed)?_c('td',{staticClass:"d-none d-lg-table-cell"},[_vm._v("\n          "+_vm._s(row.points_after)+"\n          "),(_vm.isAffected(row))?_c('span',{staticClass:"draws-dashboard__warn-icon",attrs:{"title":"Points changed"}}):_vm._e()]):_vm._e()],2)}),0):(!_vm.loading)?_c('tbody',[_c('tr',[_c('td',{attrs:{"colspan":_vm.colspan}},[_vm._v(_vm._s(_vm.emptyText))])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useAffectedResults;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__ = __webpack_require__(443);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function useAffectedResults(entityType) {
  var state = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var results = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var otherResults = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var previewing = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var previewed = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var recalculating = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function fetchAffected(_x, _x2) {
    return _fetchAffected.apply(this, arguments);
  }

  function _fetchAffected() {
    _fetchAffected = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(entityId, stateId) {
      var fetcher, _ref, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              fetcher = entityType === 'horse' ? __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].horseAffectedResults : __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].riderAffectedResults;
              _context.next = 5;
              return fetcher(entityId, stateId);

            case 5:
              _ref = _context.sent;
              data = _ref.data;
              state.value = data.data.state;
              results.value = data.data.results;
              otherResults.value = [];
              previewed.value = false;

            case 11:
              _context.prev = 11;
              loading.value = false;
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 11, 14]]);
    }));
    return _fetchAffected.apply(this, arguments);
  }

  function preview(_x3, _x4) {
    return _preview.apply(this, arguments);
  }

  function _preview() {
    _preview = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(entityId, stateId) {
      var fetcher, _ref2, data;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              previewing.value = true;
              _context2.prev = 1;
              fetcher = entityType === 'horse' ? __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].horseRecalculatePreview : __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].riderRecalculatePreview;
              _context2.next = 5;
              return fetcher(entityId, stateId);

            case 5:
              _ref2 = _context2.sent;
              data = _ref2.data;
              results.value = data.data.results;
              otherResults.value = data.data.other_results;
              previewed.value = true;

            case 10:
              _context2.prev = 10;
              previewing.value = false;
              return _context2.finish(10);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1,, 10, 13]]);
    }));
    return _preview.apply(this, arguments);
  }

  function confirmRecalculate(_x5, _x6) {
    return _confirmRecalculate.apply(this, arguments);
  }

  function _confirmRecalculate() {
    _confirmRecalculate = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(entityId, stateId) {
      var fetcher, _ref3, data;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              recalculating.value = true;
              _context3.prev = 1;
              fetcher = entityType === 'horse' ? __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].horseRecalculate : __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].riderRecalculate;
              _context3.next = 5;
              return fetcher(entityId, stateId);

            case 5:
              _ref3 = _context3.sent;
              data = _ref3.data;
              return _context3.abrupt("return", data.message);

            case 8:
              _context3.prev = 8;
              recalculating.value = false;
              return _context3.finish(8);

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1,, 8, 11]]);
    }));
    return _confirmRecalculate.apply(this, arguments);
  }

  return {
    state: state,
    results: results,
    otherResults: otherResults,
    loading: loading,
    previewing: previewing,
    previewed: previewed,
    recalculating: recalculating,
    fetchAffected: fetchAffected,
    preview: preview,
    confirmRecalculate: confirmRecalculate
  };
}

/***/ }),

/***/ 1468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"bg-white rounded mb-4 p-3",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('div',{staticClass:"d-flex justify-content-between align-items-start mb-3 affected-results__header"},[_c('page-heading',[_vm._v("Affected Results")]),_vm._v(" "),_c('div',{staticClass:"affected-results__actions"},[_c('app-button',{staticClass:"btn-block-mob",attrs:{"variant":"outline-primary","block":false},on:{"click":_vm.goBack}},[_vm._v("Back")]),_vm._v(" "),(!_vm.previewed)?_c('app-button',{staticClass:"btn-block-mob ml-lg-2",attrs:{"block":false,"loading":_vm.previewing,"disabled":!_vm.results.length},on:{"click":_vm.handlePreview}},[_vm._v("Recalculate")]):_c('app-button',{staticClass:"btn-block-mob ml-lg-2",attrs:{"block":false,"loading":_vm.recalculating},on:{"click":_vm.handleConfirm}},[_vm._v("Confirm Recalculate")])],1)],1),_vm._v(" "),(_vm.state)?_c('div',{staticClass:"affected-results__state mb-3"},[_c('span',[_c('span',{staticClass:"font-weight-bolder"},[_vm._v("Effective Date: ")]),_vm._v(_vm._s(_vm.formatDate(_vm.state.effective_date, 'long')))]),_vm._v(" "),_c('span',[_c('span',{staticClass:"font-weight-bolder"},[_vm._v("BOY Status: ")]),_vm._v(_vm._s(_vm.state.boy_status.name))]),_vm._v(" "),_c('span',[_c('span',{staticClass:"font-weight-bolder"},[_vm._v(_vm._s(_vm.type === 'horse' ? 'Horse Status' : 'Rider Status')+": ")]),_vm._v(_vm._s(_vm.type === 'horse' ? _vm.state.horse_status.name : _vm.state.rider_status.name))]),_vm._v(" "),_c('span',[_c('span',{staticClass:"font-weight-bolder"},[_vm._v("Changed By: ")]),_vm._v(_vm._s(_vm.state.changed_by.name)+" on "+_vm._s(_vm.formatDate(_vm.state.changed_by.date, 'long')))]),_vm._v(" "),(_vm.state.needs_recalculation)?_c('span',{staticClass:"text-warning"},[_vm._v("\n        Needs recalculation"),_c('span',{staticClass:"draws-dashboard__warn-icon",attrs:{"title":"Needs recalculation"}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger mb-3"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.previewed)?_c('div',{class:['alert mb-3', _vm.hasChanges ? 'alert-warning' : 'alert-success']},[(_vm.hasChanges)?[_vm._v("\n        Recalculation preview succeeded — points changed on "+_vm._s(_vm.changedCount)+" result"+_vm._s(_vm.changedCount === 1 ? '' : 's')+": "+_vm._s(_vm.affectedResultsCount)+" for this "+_vm._s(_vm.type === 'horse' ? 'horse' : 'rider')+" (see below)"),(_vm.otherResults.length)?_c('span',[_vm._v(", and "+_vm._s(_vm.otherResults.length)+" other affected result"+_vm._s(_vm.otherResults.length === 1 ? '' : 's')+" shown further down")]):_vm._e(),_vm._v(".\n        This isn't entirely normal — it may be worth double-checking these manually before confirming. To save these changes, click "),_c('strong',[_vm._v("\"Confirm Recalculate\"")]),_vm._v(" above.\n      ")]:[_vm._v("\n        Recalculation preview succeeded — no results were affected. Please double-check that no points have decreased, then click "),_c('strong',[_vm._v("\"Confirm Recalculate\"")]),_vm._v(" above to save.\n      ")],_vm._v(" "),_c('div',{staticClass:"mt-2"},[_vm._v("Before confirming, make sure the event is affiliated — if it isn't, its points will be recalculated to zero.")])],2):_vm._e(),_vm._v(" "),_c('affected-results-table',{attrs:{"rows":_vm.results,"loading":_vm.loading || _vm.previewing,"previewed":_vm.previewed,"entity-label":_vm.type === 'horse' ? 'Rider' : 'Horse',"entity-field":_vm.type === 'horse' ? 'rider' : 'horse'}}),_vm._v(" "),(_vm.previewed && _vm.otherResults.length)?[_c('h2',{staticClass:"h4 mt-4"},[_vm._v("Other Affected Results")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Other riders/horses whose points are also affected by this recalculation.")]),_vm._v(" "),_c('affected-results-table',{attrs:{"rows":_vm.otherResults,"loading":_vm.loading || _vm.previewing,"previewed":_vm.previewed,"mode":"both"}})]:_vm._e()],2),_vm._v(" "),(_vm.gateVisible)?_c('action-gate-modal',{attrs:{"error":_vm.gateError,"loading":_vm.gateLoading},on:{"confirm":_vm.submitGatePassword,"cancel":_vm.cancelGate}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/19.f291d0e3425fb1458e48.js